/* eslint-disable */

import React from "react";
import { Route, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCRMContactInfo,
  getContactSetupSkipped,
  setContactSetupSkipped,
} from "../Utils/Helpers/common";
import { getRecordByProperty } from "../components/Utils/Oidc/apiService";
import * as entityRecordAction from "../store/actions/entityRecordAction";
import M_ContactRequiredDialog from "../components/Factory/Molecules/Common/Navigations/M_ContactRequiredDialog";
import LoadingMessage from "../components/Utils/Oidc/LoadingMessage/LoadingMessage";

function ProtectedRoute({ component: Component, entityRecord, getEntityRecord, ...restProps }) {
  const isAuthenticated = restProps.user ? true : false;
  const history = useHistory();
  const location = {
    pathname: "/",
    state: { referrer: { pathname: history.location.pathname } },
  };
  const [contactChecked, setContactChecked] = React.useState(() => {
    const email = restProps.user?.profile?.email;
    if (!isAuthenticated || !email) return true;
    if (getContactSetupSkipped(email)) return true;
    const { crmContactUserId } = getCRMContactInfo();
    return !!crmContactUserId;
  });
  const [hasContact, setHasContact] = React.useState(true);
  const [contactSkipped, setContactSkipped] = React.useState(() =>
    getContactSetupSkipped(restProps.user?.profile?.email)
  );

  React.useEffect(() => {
    const email = restProps.user?.profile?.email;
    if (!isAuthenticated || !email) {
      setContactChecked(true);
      return;
    }

    if (getContactSetupSkipped(email)) {
      setContactChecked(true);
      return;
    }

    const { crmContactUserId } = getCRMContactInfo();
    if (crmContactUserId) {
      setContactChecked(true);
      setHasContact(true);
      return;
    }

    getRecordByProperty({ label: "contact", properties: { email } }).then((found) => {
      setHasContact(found);
      setContactChecked(true);
      if (!found) {
        const entitiesLoaded = entityRecord?.data?.entity?.length > 0;
        if (!entitiesLoaded) {
          getEntityRecord();
        }
      }
    });
  }, []);

  const contactEntity = React.useMemo(() => {
    const entities = entityRecord?.data?.entity;
    if (!Array.isArray(entities)) return null;
    return entities.find((e) => e?.name?.toLowerCase().includes("contact")) || null;
  }, [entityRecord]);

  const handleContactCreated = () => {
    setHasContact(true);
    const email = restProps.user?.profile?.email;
    if (email) {
      getRecordByProperty({ label: "contact", properties: { email } });
    }
  };

  const handleSkipContact = () => {
    setContactSetupSkipped(restProps.user?.profile?.email);
    setContactSkipped(true);
  };

  const showContactDialog = contactChecked && !hasContact && !contactSkipped;

  return (
    <Route
      {...restProps}
      render={(props) => {
        if (!isAuthenticated) {
          return history.push(location);
        }

        if (!contactChecked) {
          return <LoadingMessage />;
        }

        return (
          <>
            <Component {...props} />
            {showContactDialog && contactEntity && (
              <M_ContactRequiredDialog
                contactEntity={contactEntity}
                onContactCreated={handleContactCreated}
                onSkip={handleSkipContact}
              />
            )}
          </>
        );
      }}
    />
  );
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    entityRecord: state.entityRecord,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(entityRecordAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
